import { render, staticRenderFns } from "./BillingRoute.vue?vue&type=template&id=dd3f0020"
import script from "./BillingRoute.vue?vue&type=script&lang=js"
export * from "./BillingRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports